export const COMPANY_ADDRESS = '葵芳新都會廣場二期2311室';

export const COMPANY_COORDINATE_LAT = 22.357504;

export const COMPANY_COORDINATE_LNG = 114.126364;

export const GOOGLE_MAP_KEY = 'AIzaSyA0qQKbPOvp82gmd-QS5OiLaDQkr4fz4IQ';

export const PLATFORMS = {
  rakuten: 2,
  yahoo_jp: 3,
  amazon_jp: 4,
};
